import { useCallback } from 'react'

import { useLDClient } from 'launchdarkly-react-client-sdk'

import type { LaunchdarklyVariation } from '@/shared/libs/launchdarkly/types'

export const useLaunchdarklyVariation = (): LaunchdarklyVariation => {
  const ldClient = useLDClient()

  return useCallback(
    (flag, defaultValue) =>
      ldClient?.variation(flag, defaultValue) ?? defaultValue,
    [ldClient],
  )
}
